function About() {
  return (
    <section id="about" className="min-h-screen bg-white pt-28 pb-20 text-slate-900">
      <div className="container mx-auto px-4 md:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="border-b border-slate-200 pb-10">
            <span className="text-sm font-semibold uppercase tracking-[0.28em] text-slate-500">
              About Oriri Africa Fund
            </span>
            <div className="mt-6 grid gap-8 lg:grid-cols-[1.3fr_0.7fr] lg:items-end">
              <div>
                <h1 className="text-4xl font-bold leading-tight text-slate-900 md:text-5xl">
                  Advancing inclusive finance for underserved communities in Rwanda.
                </h1>
                <p className="mt-6 max-w-3xl text-lg leading-8 text-slate-600">
                  Oriri Africa Fund is a Rwanda-based initiative committed to expanding access to fair,
                  practical, and sustainable financial solutions for micro, small, and medium enterprises,
                  women entrepreneurs, and refugee-led businesses.
                </p>
              </div>
              <div className="rounded-2xl border border-slate-200 bg-slate-50 p-8">
                <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">
                  Established
                </p>
                <p className="mt-3 text-3xl font-bold text-slate-900">2024</p>
                <p className="mt-4 text-base leading-7 text-slate-600">
                  Built to support inclusive growth through disciplined capital allocation and community partnership.
                </p>
              </div>
            </div>
          </div>

          <div className="grid gap-10 py-12 lg:grid-cols-[1.1fr_0.9fr]">
            <div className="rounded-2xl border border-slate-200 bg-white p-10 shadow-sm">
              <h2 className="text-2xl font-semibold text-slate-900">Who We Are</h2>
              <p className="mt-6 text-lg leading-8 text-slate-700">
                We work to reduce barriers to finance for communities that are too often excluded from
                traditional systems. Our approach combines responsible funding with practical support so
                entrepreneurs can strengthen their businesses, generate income, and contribute to broader
                local economic development.
              </p>
              <p className="mt-6 text-lg leading-8 text-slate-700">
                By focusing on inclusion, accountability, and long-term resilience, Oriri Africa Fund
                seeks to create measurable impact for individuals, households, and the communities they serve.
              </p>
            </div>

            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-10">
              <h2 className="text-2xl font-semibold text-slate-900">Our Mission</h2>
              <p className="mt-6 text-lg leading-8 text-slate-700">
                To provide fair access to finance, mentoring, and growth support for underserved entrepreneurs
                while promoting sustainable development and meaningful social impact.
              </p>
              <div className="mt-8 border-l-4 border-slate-300 pl-5">
                <p className="text-base font-medium uppercase tracking-[0.18em] text-slate-500">
                  Guiding Principle
                </p>
                <p className="mt-3 text-lg text-slate-700">
                  Empowering communities through responsible finance and practical opportunity.
                </p>
              </div>
            </div>
          </div>

          <div className="grid gap-6 md:grid-cols-3">
            <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
              <h3 className="text-xl font-semibold text-slate-900">MSME Empowerment</h3>
              <p className="mt-4 text-base leading-7 text-slate-600">
                Supporting business stability and growth through accessible financial tools tailored to small enterprises.
              </p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
              <h3 className="text-xl font-semibold text-slate-900">Women&apos;s Inclusion</h3>
              <p className="mt-4 text-base leading-7 text-slate-600">
                Expanding opportunity for women entrepreneurs with financing structures designed for real-world needs.
              </p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
              <h3 className="text-xl font-semibold text-slate-900">Refugee Support</h3>
              <p className="mt-4 text-base leading-7 text-slate-600">
                Promoting economic participation by helping displaced entrepreneurs rebuild with dignity and stability.
              </p>
            </div>
          </div>

          <div className="mt-12 rounded-2xl border border-slate-200 bg-slate-900 px-8 py-10 text-white">
            <div className="grid gap-8 md:grid-cols-3">
              <div>
                <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-300">Founded</p>
                <p className="mt-3 text-4xl font-bold">2024</p>
              </div>
              <div>
                <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-300">Entrepreneurs Supported</p>
                <p className="mt-3 text-4xl font-bold">100+</p>
              </div>
              <div>
                <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-300">Core Focus Areas</p>
                <p className="mt-3 text-4xl font-bold">3</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
